
import Chevron from '@/components/svg-components/Chevron.vue';
import ByteCookieIcon from '@/components/svg/logo/logo-circles-only.svg?inline';
import useResponsiveness from '@/mixins/useResponsiveness';
import { ProfileStoreKey } from '@/models/Profile';
import useProfileState from '@/state/profile/profileState';
import ProfileBasicEditor from '@/views/profile/components/editors/ProfileBasicEditor.vue';
import ProfilePdfUploadBanner from '@/views/profile/components/profile-pdf-upload/ProfilePdfUploadBanner.vue';
import ProfileBasicView from '@/views/profile/components/views/ProfileBasicView.vue';
import { defineComponent, onMounted, ref } from 'vue';
import useUser from '@/mixins/useUser';
import useProfilePdfUploadPopup from '@/views/profile/composables/useProfilePdfUploadPopup';

export default defineComponent({
  components: {
    ByteCookieIcon,
    ProfileBasicEditor,
    ProfilePdfUploadBanner,
    ProfileBasicView,
    Chevron
  },
  setup() {
    const profileLink = { name: 'profile' };
    const avatarRerenderKey = ref(0);
    const { resetBannerDismissed } = useProfilePdfUploadPopup();
    const {
      init, isLoading, user, isEditSectionOpen, toggleEditSection
    } = useProfileState(ProfileStoreKey.PROFILE, undefined, 'dashboard-user-profile-status');
    init();
    const { isMobileWidth } = useResponsiveness();

    const { tUser: t } = useUser('self');

    onMounted(() => {
      resetBannerDismissed();
      if (!isEditSectionOpen('basic')) toggleEditSection('basic');
    });

    const { isFreelancer } = useUser(user);

    return {
      t,
      isEditSectionOpen,
      avatarRerenderKey,
      isLoading,
      isMobileWidth,
      user,
      profileLink,
      isFreelancer,
    };
  }
});
